import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TimelineService} from '../timeline.service';
import {Storyboard} from 'storyboard-renderer';
import {Template} from "../../../../template/shared/template";
import {StoryboardRendererAudioService} from "../../preview/preview-render-component/storyboard-renderer-audio.service";
import {Hotkey, HotkeysService} from 'angular2-hotkeys';

@Component({
  selector: 'app-control-bar',
  templateUrl: './control-bar.component.html',
  styleUrls: ['./control-bar.component.scss'],
})
export class ControlBarComponent implements OnInit {

  @Output() newLayerEvent = new EventEmitter();
  @Input() storyboard: Storyboard;

  public get historyLength() {
    return this.timelineService.previousVersions.length;
  }

  constructor(public timelineService: TimelineService, private audioService: StoryboardRendererAudioService, private hotkeysService: HotkeysService) {}

  ngOnInit() {
      this.hotkeysService.add(new Hotkey(['alt++', 'alt+-', 'alt+space', 'alt+backspace', 'alt+right', 'alt+left', 'alt+ctrl+right', 'alt+ctrl+left', 'alt+shift+right', 'alt+shift+left'], (event: KeyboardEvent, combo: string): ExtendedKeyboardEvent => {
        if (combo == 'alt++' && !this.isZoomInDisabled() ) {
          this.timelineService.zoomIn();
        }
        if (combo == 'alt+-' && !this.isZoomOutDisabled() ) {
          this.timelineService.zoomOut();
        }
        if (combo == 'alt+space' && !this.isZoomOutDisabled() ) {
          this.togglePlayback();
        }
        if (combo == 'alt+backspace') {
          this.resetTimelinePosition();
        }
        if (combo == 'alt+right') {
          this.stepSeek(1, 1000);
        }
        if (combo == 'alt+left') {
          this.stepSeek(-1, 1000);
        }
        if (combo == 'alt+ctrl+right') {
          this.stepSeek(1, 10 * 1000);
        }
        if (combo == 'alt+ctrl+left') {
          this.stepSeek(-1, 10 * 1000);
        }
        if (combo == 'alt+shift+right') {
          this.stepSeek(1, 250);
        }
        if (combo == 'alt+shift+left') {
          this.stepSeek(-1, 250);
        }
        let e: ExtendedKeyboardEvent = event;
        e.returnValue = false; // Prevent bubbling
        return e;
    }));
  }

  public undo(): void {
    this.timelineService.undo();
  }

  isAllowedCreateLayerWithoutAudio() {
    return this.storyboard.attached_audio || this.storyboard.constructor.name === Template.name;
  }

  play() {
    if (this.timelineService.playerControl.paused()) {
      this.timelineService.playerControl.play()
    }
  }

  pause() {
    if (this.timelineService.playerControl.playing()) {
      this.timelineService.playerControl.pause();
    }
  }

  togglePlayback() {
    if (this.timelineService.playerControl.playing()) {
      this.pause();
    } else {
      this.play();
    }
  }

  resetTimelinePosition() {
    this.timelineService.playerControl.seekToBeginning();
  }

  stepSeek(direction: number, timeStep: number) {
    let currentTime = this.timelineService.playerControl.getCurrentTime();
    // Don't allow seeking below 0
    if (direction > 0 && currentTime.as_milliseconds + timeStep > this.timelineService.playerControl.getMaxTime().as_milliseconds ) {
      timeStep = this.timelineService.playerControl.getMaxTime().as_milliseconds - currentTime.as_milliseconds;
    }

    // Don't allow seeking above max
    else if (direction < 0 && currentTime.as_milliseconds - timeStep < this.timelineService.playerControl.getMinTime().as_milliseconds ) {
      timeStep = currentTime.as_milliseconds;
    }
    
    // This seeks the ticker
    currentTime.increaseByMilliseconds(direction * timeStep);

    // But this syncs the audio
    this.timelineService.playerControl.seekTo(currentTime);
  }
  
  zoomIn() {
    this.timelineService.zoomIn();
  }

  zoomOut() {
    this.timelineService.zoomOut();
  }

  resetZoom() {
    this.timelineService.setZoom(1);
  }

  getZoom() {
    return (this.timelineService.getZoom() * 100).toFixed(0);
  }

  isZoomInDisabled() {
    return this.timelineService.isZoomInDisabled();
  }

  isZoomOutDisabled() {
    return this.timelineService.isZoomOutDisabled();
  }

  createLayer() {
    this.newLayerEvent.next();
  }

  mosueWheelZoom(event) {
    event.preventDefault();
    if (event.deltaY < 0 && !this.isZoomInDisabled() ) {
      this.timelineService.zoomIn();
    }
    if (event.deltaY > 0 && !this.isZoomOutDisabled() ) {
      this.timelineService.zoomOut();
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/timeline/control-bar/control-bar.component.ts